import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import productsStore from 'stores/new/Products'
import productAction from 'actions/Product'
import ProductFactory from 'factories/Products'
import ShelfProduct from 'components/ShelfProductV2'
import style from './style.scss'; //NOSONAR

export const ProductBlock = (props) => {
    const {
        store,
        campaignData,
        options,
        single,
        callbackIsSingle,
    } = props
    
    const [products, setProducts] = useState(null)
    const collectionId = options.collectionId
    const listTitle = `Grilla Texto Card S/M ${options.data.position} - ${options.data.title}`

    useEffect(() => {
        const _products = store.products?.get(collectionId)
        setProducts(_products?.toList()?.toArray())
    }, [store])

    useEffect(() => {
        productAction.getProductsCollection(options.collectionId, campaignData?.campaign)
    }, [campaignData])

    useEffect(() => {
        callbackIsSingle(products?.length === 1)
    }, [products, single])

    const filteredProducts = products?.filter(_prod => {
        return ProductFactory.hasStock(_prod.items[0])
    })

    function createGtmData(_data, index) {
        return {
            'name': _data.productName,
            'id': _data.item.itemId,
            'refId': _data.item.referenceId[0].Value,
            'price': _data.item.prices.regular,
            'brand': _data.brand,
            'category': _data.categories[0] || '',
            'variant': '',
            'list': listTitle,
            'position': `slot${index}`,
            'type': 'GridTextAndCardSmallOrMedium',
        }
    }

    return (
        <div className={`product-block-wrapper ${single ? 'product-block-wrapper-is-single' : ''}`}>
            {filteredProducts?.slice(0, single ? 1 : 2).map((_prod, i) => {
                return (
                    <ShelfProduct key={i} product={_prod} addToList={{active: single}} listTitle={listTitle} gtmData={createGtmData(_prod, i)} customSize={{mobile: 360, desktop:360}}/>
                )
            })}
        </div>
    )
}

ProductBlock.propTypes = {
    store: PropTypes.object,
    options: PropTypes.shape({
        collectionId: PropTypes.string,
        data: PropTypes.object,
    }),
    campaignData: PropTypes.object,
    single: PropTypes.bool,
    callbackIsSingle: PropTypes.func,
    addToList: PropTypes.object,
}

export default productsStore.wrapConsumer(ProductBlock)